module.exports = __webpack_public_path__ + "static/media/grad8.851072d6.jpg";